import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SportsNavBar from "../../components/common/SportsNavBar";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { fetchNBANews } from "../../services/api";

function NBA() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    const data = await fetchNBANews();
    setArticles(data);
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>NBA News | Bharat Abroad Sports</title>
        <meta
          name="description"
          content="Latest NBA scores, team standings, player trades, and match highlights."
        />
      </Helmet>

      <SportsNavBar />

      <div
        style={{ background: "#f5f5f5", minHeight: "100vh", padding: "20px" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <NewsSection title="NBA News" articles={articles} category="nba" />
        </div>
      </div>
    </>
  );
}

export default NBA;
